var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRateReviewStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1508 39.1198C24.5808 38.8199 23.8998 38.8196 23.3295 39.1189L12.779 44.6573C11.3428 45.4112 9.66538 44.1914 9.94005 42.5927L11.9541 30.8704C12.0634 30.2342 11.852 29.5851 11.3891 29.1352L2.8517 20.8379C1.6869 19.7058 2.32808 17.7295 3.93562 17.4969L15.7191 15.7918C16.3567 15.6995 16.9081 15.2994 17.1936 14.7219L22.4686 4.05006C23.187 2.59664 25.2598 2.59664 25.9782 4.05006L31.2532 14.7219C31.5387 15.2994 32.0901 15.6995 32.7277 15.7918L44.5112 17.4969C46.1187 17.7295 46.7599 19.7058 45.5951 20.8379L37.0577 29.1352C36.5948 29.5851 36.3835 30.2342 36.4928 30.8704L38.506 42.5881C38.7808 44.1876 37.1016 45.4075 35.6654 44.6518L25.1508 39.1198Z",
    fill: "#354D9E",
    stroke: "#354D9E",
    strokeWidth: 0.734043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6722 20.1975H25.3835V31.1592H24.256V21.1997H21.6722V20.1975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRateReviewStar1);
export default __webpack_public_path__ + "static/media/IconRateReviewStar-1.9077639fc98e52d9aeab8b55f5ad9a3a.svg";
export { ForwardRef as ReactComponent };